import SubmissionReview from '@/components/admin/SubmissionReview'

const SubmissionReviewPage = () => {
  return <SubmissionReview />
}

export default SubmissionReviewPage